const question5 = {
    'question': 'Jaki jest czas oczekiwania na wizytę u psychogeriatry?',
    'answer': '<p>Robimy wszystko, aby pacjenci nasi centrum mogli jak najszybciej umówić się do odpowiedniego specjalisty. Aktualnie średni czas oczekiwania na wizytę pierwszorazową u psychiatry dla osób starszych w Toruniu to ok. 1-2 tygodnie.</p>' +
        '<p>Dbamy o to, aby nasi pacjenci otrzymywali pomoc specjalisty możliwie szybko i bez niepotrzebnych opóźnień. Zachęcamy do kontaktu z naszą rejestracją.</p>',
}

export default question5;